export const DEFAULT_VIEW = {
  order: {
    ascending: true,
    dataKey: 'sid'
  }
};
